module.exports = __webpack_public_path__ + "img/green_074.a0f26edd.png";